import Types from './Types';

const INITIAL_STATE = {
    teacherassistants: [],
    teacher: {},
    isLoading: false,
    count: ''
};

export default function teacherassistants(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_TEACHER_ASSISTANTS_SUCCESS: {
            return {
                ...state,
                teacherassistants: payload.data,
                count: payload.data.length
            };
        }

        case Types.GET_TEACHER_ASSISTANT_SUCCESS: {
            return {
                ...state,
                teacherassistant: payload
            };
        }

        case Types.EDIT_TEACHER_ASSISTANT_SUCCESS: {
            let data = payload.data;
            const teacherassistants = state.teacherassistants;
            let idx = 0;
            teacherassistants.forEach((table, index) => {
                if (table.id === data.id) {
                    idx = index;
                    return;
                }
            });

            teacherassistants[idx] = data;
            return {
                ...state,
                teacherassistants: teacherassistants
            };
        }

        // create
        case Types.CREATE_TEACHER_ASSISTANT_SUCCESS: {
            const data = payload.data.data;
            let newArray = state.teacherassistants.slice();
            let index = state.teacherassistants.length + 1;
            newArray.splice(index, 0, data);
            return {
                ...state,
                teacherassistants: newArray
            };
        }
        case Types.ADD_TEACHER_ASSISTANTS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.DELETE_TEACHER_ASSISTANT_SUCCESS: {
            const newteacherassistants = state.teacherassistants.filter((item) => item.id !== payload);
            return {
                ...state,
                teacherassistants: newteacherassistants
            };
        }
        default: {
            return state;
        }
    }
}
